import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Outlet, useLocation } from "react-router-dom"
import { logOut } from "../../store/reducers/authReducer"
import { AppLink } from "../common/link/AppLink"
import styles from './Header.module.css'

export const Header = () => {
    const { token, email } = useSelector(state => state.auth)
    const dispatch = useDispatch()
    const location = useLocation()

    const handleExit = async () => {
        try {
            await dispatch(logOut())
        } catch (e) {
            alert(e.code)
        }
    }

    return <header
        className={location.pathname !== '/auth' ? styles.header : `${styles.header} ${styles.header__headerHidden}`}
    >
        <span className={styles.header__userInfo}>
            {email && <span className={styles.header__email}>{email}</span>}
        </span>
        <span className={styles.header__userActions}>
            {location.pathname.includes('player') ?
                <span className={styles.header__mode}>{token && <AppLink
                    to='/builder'>Constructor</AppLink>}</span> :
                <span className={styles.header__mode}><AppLink
                    to='/player'>Player</AppLink></span>
            }
            {token ?
                <AppLink action={handleExit}>Exit</AppLink>
                :
                <AppLink to='/auth'>Enter</AppLink>
            }
        </span>
        <Outlet />
    </header>
}